import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable({
  providedIn: 'root'
})
export class _GeoService extends CRUDBasicService {

  private apiUrl = 'https://nominatim.openstreetmap.org/search?format=json&q=';

  getCoordinates(address: string): Observable<{ lat: number; lon: number }> {
    return this.httpClient.get<any[]>(`${this.apiUrl}${encodeURIComponent(address)}`).pipe(
      map(response => {
        if (response.length > 0) {
          return { lat: parseFloat(response[0].lat), lon: parseFloat(response[0].lon) };
        } else {
          throw new Error('Keine Koordinaten gefunden.');
        }
      })
    );
  }

}
